import React from 'react';
import {
  Header,
  Segment,
} from 'semantic-ui-react';

import {
  CustomContainer,
  FollowingBtn,
  FollowingBtnGuide,
  ShareBtn,
} from '../../common';
import {
  TwentyFourHourToTwelveHourFormat,
} from '../../Utils';

export default ({
  authed,
  isMobile,
  data: {
    // description,
    // num_articles,
    // trends,
    alias,
    avg_num_articles_per_day: avgNumArticlesPerDay,
    headline,
    id,
    popular_time: popularTime,
    tag,
    title,
  },
}) => (
  <CustomContainer>
    <Segment>
      {
        authed ? (
          <FollowingBtn
            platform="ptt"
            type="board"
            id={id}
          />
        ) : (
          <FollowingBtnGuide />
        )
      }
      <ShareBtn />
      <Header
        as={isMobile ? 'h5' : 'h4'}
        floated="right"
        color="teal"
      >
        {tag}
      </Header>
      <Header
        as={isMobile ? 'h3' : 'h2'}
        icon
        textAlign="center"
      >
        <Header.Content
          as={isMobile ? 'h3' : 'h2'}
        >
          {alias ?? title}
          {' '}
          (
          {title}
          )
          <Header.Subheader>
            {headline}
          </Header.Subheader>
          <Header.Subheader>
            熱門時段:
            {' '}
            {TwentyFourHourToTwelveHourFormat(popularTime)}
            {' '}
            (UTC +8)
          </Header.Subheader>
          <Header.Subheader>
            每日平均文章數:
            {' '}
            {avgNumArticlesPerDay}
          </Header.Subheader>
        </Header.Content>
      </Header>
    </Segment>
  </CustomContainer>
);
